import React, { useEffect, useRef } from "react";

export default function CommonToast({
    title = "Success!",
    message,
    type = "success",
    duration = 5000,
    onClose,
}) {
    const timerRef = useRef(null);
    const startTimeRef = useRef(null);
    const remainingRef = useRef(duration);

    const startTimer = () => {
        startTimeRef.current = Date.now();
        timerRef.current = setTimeout(onClose, remainingRef.current);
    };

    const clearTimer = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    };

    useEffect(() => {
        startTimer();
        return clearTimer;
    }, []);

    const handleMouseEnter = () => {
        clearTimer();
        const elapsed = Date.now() - startTimeRef.current;
        remainingRef.current = Math.max(0, remainingRef.current - elapsed);
    };

    const handleMouseLeave = () => {
        startTimer();
    };

    return (
        <div
            className={`toast-card ${type}`}
            role="alert"
            onClick={onClose}               
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className={`toast-type-icon ${type}`} />

            <span className="toast-bar" />

            <div className="toast-content">
                <h4>{title}</h4>
                <p>{message}</p>
            </div>


            <button
                className="toast-close"
                onClick={(e) => {
                    e.stopPropagation();  
                    onClose();
                }}
            >
                ×
            </button>
        </div>
    );
}
